import { apiFetch } from './client';

export interface AdminApiKey {
  id: number;
  name: string;
  prefix: string;
  created_at: string;
  last_used_at: string | null;
  revoked_at: string | null;
}

export const adminApiKeysApi = {
  list: () => apiFetch<AdminApiKey[]>('/admin/api-keys', { cache: 'no-store' }),
  create: (body: { name: string }) =>
    apiFetch<{ key: string; api_key: AdminApiKey }>('/admin/api-keys', {
      method: 'POST', body: JSON.stringify(body), cache: 'no-store'
    }),
  revoke: (id: number) => apiFetch<AdminApiKey>(`/admin/api-keys/${id}/revoke`, { method: 'POST' })
};
